export const playlistItemsLength = (modelPlaylists) => {
    if (modelPlaylists && modelPlaylists.length) {
        //sum characters of name property of all playlists
        const totalLength = modelPlaylists.reduce((acc, playlist) => acc + playlist.Name.length, 0)
        return totalLength
    }
    return 0
}

const numberOfCompCardsAvailable = (groupOfModels) => {
    return groupOfModels.filter(model => model.Playlists.some(playlist => playlist.CompCard)).length;
}

const hasAtLeastOneCompCard = (groupOfModels) => {
    return groupOfModels.some(model => model.Playlists.some(playlist => playlist.CompCard));
}

const hasAllCompCards = (groupOfModels) => {
    return groupOfModels.every(model => model.Playlists.some(playlist => playlist.CompCard));
}

export const checkGroupsForCompCards = (group) => {
    return {
        ...group,
        hasCompCard: hasAtLeastOneCompCard(group.Models),
        hasAllCompCards: hasAllCompCards(group.Models),
        numberOfCompCardsAvailable: !group.hasAllCompCards ? numberOfCompCardsAvailable(group.Models) : 0
    }
}
